import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/vercel/path0/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
